import React,{useEffect, useState} from 'react';
import logo from './logo.svg';
import Header from '../components/header'
import ArticleList from '../components/articleList';
import { redirect } from "react-router-dom";

const Root: React.FC = ()=>{

  return (
    <div>
      <Header></Header>
      <ArticleList></ArticleList>
    </div>
  );
}

export default Root